import { App } from '@gin-betting/core';

import { useMemoSelector } from 'hooks';
import { selectOverviewScores } from 'selectors';

interface Input {
    matchId: string;
    subText: string | null;
}

interface Output {
    subText: string | null;
}

const useFixtureIceHockey = ({ matchId, subText }: Input): Output => {
    const { currentMatchPart } = useMemoSelector(selectOverviewScores, {
        matchId,
    });

    if (
        currentMatchPart &&
        currentMatchPart.type === App.MetaTypes.TYPE_BULLETS
    ) {
        return {
            subText: null,
        };
    }

    return { subText };
};

export default useFixtureIceHockey;
